export default __webpack_public_path__ + "static/media/logo.b2c56c70.svg";